import { Collapse } from 'antd';

export const AccessRightAccordion = () => {
  return <Collapse expandIconPosition="end" />;
};
